import { Tooltip } from 'antd';
import propType from 'prop-types';
import React from 'react';
import { FacebookShareButton } from 'react-share';
import { useClipboard } from '../../hooks';

export default function ShareArticle({ shareUrl, content, hashtag }) {
  const [isCopied, onCopy] = useClipboard(shareUrl);

  return (
    <section className="share">
      <h3 className="share__title">
        Did you like this article? Spread the word!
      </h3>
      <FacebookShareButton
        url={shareUrl}
        quote={content.replace(/<[^>]*>?/gm, '')}
        hashtag={hashtag}
      >
        <img src="/svg/blog-detail/icon-fb-share.svg" alt="Share on facebook" />
      </FacebookShareButton>
      <Tooltip
        title="Copied to clipboard"
        placement="top"
        arrowPointAtCenter
        visible={isCopied}
      >
        <button className="share__copy-link" type="button" onClick={onCopy}>
          <img src="/svg/blog-detail/icon-link-share.svg" alt="share" />
        </button>
      </Tooltip>
    </section>
  );
}

ShareArticle.defaultProps = {
  content: '',
  hashtag: ''
};

ShareArticle.propTypes = {
  shareUrl: propType.string.isRequired,
  content: propType.string,
  hashtag: propType.string
};
